import { useState, useEffect } from 'react';
import FetchApi from './getAxios';

export const useFetch = (url, info) => {

    const [loading, setloading] = useState(false);
    const [data, setdata] = useState([]);

    const fetchData = async (e) => {
        setloading(true);

        FetchApi.post(`${ url }`, info)
            .then((res) => {
                if (res.success === false) {
                    setloading(false);
                    setdata(res.data);
                } else {
                    setloading(false);
                    setdata(res.data);
                }
            })
            .catch((error) => {
                setloading(false);
                if (error) {
                    setdata([]);
                }
            });
    };
    // useEffect(() => {
    //     fetchData();
    // }, []);

    return { loading, data, setdata, fetchData };
};
